module.exports = __webpack_public_path__ + "media/images/sp/stores/kyoto/kyoto_sns_02-b1d87db2dd9c078871cd9590077de8de.jpg";